import { keyBy, keys, omit, pick } from 'lodash';
import { dlColumnKeys } from '../../constants';

export const filterTransformer = (columns, filters, defaultTransformer) => {
  const columnMap = keyBy(columns, 'key');
  return keys(filters)
    .map(key => {
      const value = filters[key];
      if (
        key !== dlColumnKeys.customerTier &&
        (value === undefined || value === null || value === '' || value.val === '')
      )
        return null;
      const column = columnMap[key];
      if (!column) return null;
      return column.transformer
        ? column.transformer(value, column)
        : defaultTransformer(value, column.property);
    })
    .filter(i => i);
};

export const rowTransformer =
  (columns, defaultTransformer, ...topLevelData) =>
  row => {
    return {
      ...pick(row, topLevelData),
      dimensions: [...filterTransformer(columns, omit(row, topLevelData), defaultTransformer)],
    };
  };

export const pivotWider =
  (transformers, defaultTransformer, store, ...topLevelData) =>
  row => {
    const output = { ...pick(row, topLevelData) };
    row?.dimensions?.forEach(dim => {
      const transformer = transformers[dim.property] || defaultTransformer;
      output[dim.property] = transformer(dim, { store });
    });
    return output;
  };
